import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电视剧分类", to: "/category/series" },
  { label: "排行榜", to: "/ranking" },
  { label: "新闻", to: "/news" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
    window.scrollTo({ top: 0 });
  }, [location.pathname]);

  const handleSearch = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    navigate(value ? `/category/series?q=${encodeURIComponent(value)}` : "/category/series");
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `relative whitespace-nowrap px-3 py-2 text-sm font-label transition-colors ${
      isActive ? "text-primary-600" : "text-foreground-700 hover:text-primary-600"
    }`;

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 w-full items-center gap-4 px-4 md:h-[72px] md:px-6">
        <Link to="/" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-600 text-lg text-background-50 shadow-sm">
            <i className="ri-book-2-line" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
              金瓶梅<span className="text-primary-600">3</span>
            </span>
            <span className="mt-0.5 text-[10px] font-label tracking-[0.3em] text-foreground-500">
              影视大全
            </span>
          </span>
        </Link>

        <nav className="ml-6 hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.to === "/"} className={linkClass}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <form onSubmit={handleSearch} className="ml-auto hidden md:block">
          <div className="flex h-10 w-56 items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3.5 transition-colors focus-within:border-primary-400 xl:w-72">
            <i className="ri-search-line text-base text-foreground-400" />
            <input
              type="text"
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索剧名、演员…"
              className="h-full w-full bg-transparent text-sm font-label text-foreground-900 outline-none placeholder:text-foreground-400"
            />
          </div>
        </form>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMobileOpen((prev) => !prev)}
          className="ml-auto flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-xl text-foreground-800 lg:hidden"
        >
          <i className={mobileOpen ? "ri-close-line" : "ri-menu-line"} />
        </button>
      </div>

      {mobileOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-4 lg:hidden">
          <form onSubmit={handleSearch} className="mb-3">
            <div className="flex h-11 items-center gap-2 rounded-full border border-background-300 bg-background-100 px-4 transition-colors focus-within:border-primary-400">
              <i className="ri-search-line text-base text-foreground-400" />
              <input
                type="text"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索剧名、演员…"
                className="h-full w-full bg-transparent text-sm font-label text-foreground-900 outline-none placeholder:text-foreground-400"
              />
            </div>
          </form>
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `flex items-center justify-between rounded-md px-4 py-3 text-sm font-label ${
                    isActive
                      ? "bg-primary-50 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-base text-foreground-400" />
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}